import * as serviceContext from './serviceContext';
import { BASE_URL_M_ADMIN } from '../config';

let options = {};
let headers = new Headers();
let token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json');
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function getAllPackages() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/package`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getPackagesById(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/package/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getPackagesLicenceById(id) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/package/getbylicense/${id}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}